import { API_ROUTE_ADMIN_LOCATIONS } from '@/resources/api-routes'
import { post } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export const add = (payload: {
  code: string
  customerId: number
  hidden?: boolean
  name: string
  departmentId: number
  email: string
  customerAddressId: number
  accountingCode?: string | null
  dim1?: string | null
  dim2?: string | null
  dim3?: string | null
  dim4?: string | null
  description: string
}) => post<null>(API_ROUTE_ADMIN_LOCATIONS, payload, IS_NEW_BACKEND_API)
